// extracted by mini-css-extract-plugin
export default {"LoaderOverlay":"Loader_LoaderOverlay__0R-WQ","LoaderBox":"Loader_LoaderBox__ucpNJ","LoaderText":"Loader_LoaderText__YDa4B"};